module.exports = new __parcel__URL__("obscured-by-clouds.071ffa91.jpg").toString();